import { availableAuthRoutes } from "../../auth/constants";
import { AuthRoute } from "../../auth/wrappers/AuthRoute";

export const AuthRoutes = availableAuthRoutes.map((path) => {
  return AuthRoute(path);
});
